import MembershipHeaderWithStatus from './MembershipHeaderWithStatus';

export default MembershipHeaderWithStatus;
